import React, { useEffect, useRef, useState } from "react";
import OfferingImg from "../../../assets/Offering.png";
import { PiCertificateThin } from "react-icons/pi"
import { TiDocumentText } from "react-icons/ti";
import { SiCodementor } from "react-icons/si";
import { LiaLeanpub } from "react-icons/lia";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";

const Offerings = [
    {
        title: "Skill-Based Career Tracks",
        description:
            "Follow structured, goal-oriented career paths designed to systematically build expertise aligned with evolving industry demands.",
        icon: <TiDocumentText />
    },
    {
        title: "Career-Focused Training",
        description:
            "Engage in practical, outcome-driven learning experiences that bridge the gap between academic education and professional success.",
        icon: <PiCertificateThin />
    },
    {
        title: "Hands-on Projects",
        description:
            "Work on real-world projects that strengthen practical understanding and build confidence to succeed in competitive industries.",
        icon: <AiOutlineFundProjectionScreen />
    },
    {
        title: "Expert Mentors",
        description:
            "Learn from experienced industry professionals who share practical insights, guidance, and knowledge to strengthen skills.",
        icon: <SiCodementor />
    },
    {
        title: "Certification Programs",
        description:
            "Earn recognized certifications that validate your knowledge, strengthen your resume, and improve career opportunities.",
        icon: <PiCertificateThin />
    },
    {
        title: "Structured Learning Paths",
        description:
            "Follow well-designed learning paths that build strong fundamentals while advancing skills toward industry expertise.",
        icon: <LiaLeanpub />
    }
];

export const OurOfferings = () => {
    const ref = useRef();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );

        if (ref.current) observer.observe(ref.current);
    }, []);

    return (
        <section className="py-20 bg-gray-100 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 space-y-14">

                {/* TITLE */}
                <div className="text-center space-y-3">
                    <h2 className="text-3xl md:text-4xl font-bold">
                        Our Offerings
                    </h2>

                    <p className="text-gray-600 text-lg">
                        Industry-focused programs designed to transform learning into career success.
                    </p>
                </div>

                {/* MAIN GRID */}
                <div
                    ref={ref}
                    className="grid lg:grid-cols-3 gap-10 items-center"
                >

                    {/* LEFT CARDS */}
                    <div className="space-y-8">
                        {Offerings.slice(0, 3).map((item, i) => (
                            <div
                                key={i}
                                className={`bg-white rounded-2xl p-6 shadow-md flex gap-4 transition-all duration-700 items-center
                ${visible ? "translate-x-0 opacity-100" : "-translate-x-16 opacity-0"}`}
                            >

                                <div className="bg-blue-500 text-white w-14 h-14 text-3xl flex items-center justify-center rounded-lg  shrink-0">
                                    {item.icon}
                                </div>

                                <div>
                                    <h3 className="font-semibold text-lg">
                                        {item.title}
                                    </h3>

                                    <p className="text-gray-600 text-sm mt-1">
                                        {item.description}
                                    </p>
                                </div>

                            </div>
                        ))}
                    </div>

                    {/* CENTER IMAGE */}
                    <div className="md:flex hidden justify-center">
                        <img
                            src={OfferingImg}
                            alt="Offering"
                            className={`rounded-xl max-w-[350px] w-full transition-all duration-1000
              ${visible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}
                        />
                    </div>

                    {/* RIGHT CARDS */}
                    <div className="space-y-8">
                        {Offerings.slice(3, 6).map((item, i) => (
                            <div
                                key={i}
                                className={`bg-white rounded-2xl p-6 shadow-md flex gap-4 transition-all duration-700 items-center
                ${visible ? "translate-x-0 opacity-100" : "translate-x-16 opacity-0"}`}
                            >

                                <div className="bg-blue-500 text-white w-14 h-14 text-3xl flex items-center justify-center rounded-lg text-xl shrink-0">
                                    {item.icon}
                                </div>

                                <div>
                                    <h3 className="font-semibold text-lg">
                                        {item.title}
                                    </h3>

                                    <p className="text-gray-600 text-sm mt-1">
                                        {item.description}
                                    </p>
                                </div>

                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    );
};